/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IBirthHistory } from 'app/shared/model/birth-history.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { IHospital } from 'app/shared/model/hospital.model';
import { Frequency } from 'app/shared/model/enumerations/frequency.model';

export interface IApgarScore {
  id?: string;
  appearance?: number;
  pulse?: number;
  grimace?: number;
  activity?: number;
  respiration?: number;
  frequency?: keyof typeof Frequency | null;
  active?: boolean;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  cursor?: number;
  birthHistory?: IBirthHistory;
  recordedBy?: IDoctor;
  recordedAt?: IHospital;
}

export const defaultValue: Readonly<IApgarScore> = {
  active: false,
};
